import { decryptJWT as decryptJWTData } from 'modules/common/utils/decryptJWT';

export const decryptJWT = (jwtData: string, isEncrypted: boolean) =>
  decryptJWTData({ isEncrypted, jwt: jwtData });
